import React, { useEffect } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { AddAnnouncementFormWrapper } from './announcement.style';
import { useAnnouncement } from '../hooks/useAnnouncement';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export const AnnouncementForm = (props: any): any => {
  const [form] = Form.useForm();
  const { onVisibleChange, onReload, category } = props;
  const { onSaveAnnouncement, error } = useAnnouncement();

  const handleSubmit = () => {
    onSaveAnnouncement({ ...form.getFieldsValue() }, form, onVisibleChange, onReload);
  };

  return (
    <AddAnnouncementFormWrapper>
      <Form form={form} layout="vertical" size="large">
        <Form.Item label="Category" name={['category', 'title']}>
          <Select defaultValue=" Select Category">
            {category.map((item: any) => (
              <Select.Option value={item.title}>{item.title}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Title" name="title">
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" onClick={handleSubmit}>
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddAnnouncementFormWrapper>
  );
};

export default AnnouncementForm;
